module.exports = __webpack_public_path__ + "static/img/best.3aea2c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/integration/best.svg
// module id = 6MVF
// module chunks = 134